var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "border"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": _vm.src
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('div', {
    staticClass: "w-100 h-100 pa-20 pa-md-30 py-lg-16 px-xl-60 d-flex align-center border-lg-start"
  }, [_c('div', {
    staticClass: "w-100"
  }, [_c('h6', {
    staticClass: "font-weight-medium page-text-lg pb-12 pb-lg-14 mb-14 mb-lg-16 w-100 border-bottom"
  }, [_vm._v(" Contact Manager for more "), _c('span', {
    staticClass: "color-point"
  }, [_vm._v("information below")])]), _c('v-row', {
    staticClass: " ma-n2 ma-md-n4 my-lg-n10 font-size-14 font-size-lg-16"
  }, [_vm.name ? _c('v-col', {
    staticClass: "pa-2 pa-md-4 py-lg-10 d-flex",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('p', {
    staticClass: "font-weight-bold color-grey-2c mr-6 mr-lg-16 w-40px w-lg-60px"
  }, [_vm._v(" Manager ")]), _c('p', {
    staticClass: "color-grey-51"
  }, [_vm._v(" " + _vm._s(_vm.name) + " ")])]) : _vm._e(), _vm.tel ? _c('v-col', {
    staticClass: "pa-2 pa-md-4 py-lg-10 d-flex",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('p', {
    staticClass: "font-weight-bold color-grey-2c mr-6 mr-lg-16 w-40px w-lg-60px"
  }, [_vm._v(" TEL ")]), _c('p', {
    staticClass: "color-grey-51"
  }, [_vm._v(" " + _vm._s(_vm.tel) + " ")])]) : _vm._e(), _vm.mail ? _c('v-col', {
    staticClass: "pa-2 pa-md-4 py-lg-10 d-flex",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('p', {
    staticClass: "font-weight-bold color-grey-2c mr-6 mr-lg-16 w-40px w-lg-60px"
  }, [_vm._v(" E-MAIL ")]), _c('p', {
    staticClass: "color-grey-51"
  }, [_vm._v(" " + _vm._s(_vm.mail) + " ")])]) : _vm._e(), _vm.fax ? _c('v-col', {
    staticClass: "pa-2 pa-md-4 py-lg-10 d-flex",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('p', {
    staticClass: "font-weight-bold color-grey-2c mr-6 mr-lg-16 w-40px w-lg-60px"
  }, [_vm._v(" FAX ")]), _c('p', {
    staticClass: "color-grey-51"
  }, [_vm._v(" " + _vm._s(_vm.fax) + " ")])]) : _vm._e()], 1)], 1)])])], 1)], 1), _vm.link ? _c('a', {
    staticClass: "detail-link-wrap d-block mt-20 mt-lg-36",
    style: 'background-image:url(' + _vm.linkBg + ');',
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "detail-link color-white d-flex flex-column align-center justify-center text-center px-20 py-50 py-lg-84"
  }, [_c('h3', {
    staticClass: "tit font-weight-medium mb-14 mb-lg-28"
  }, [_vm._v(" Check the product details on the homepage ")]), _c('v-btn', {
    staticClass: "min-w-140px min-w-lg-180px font-size-14 font-size-lg-16",
    attrs: {
      "outlined": "",
      "color": "rgba(255, 255, 255, 0.5)"
    }
  }, [_c('span', {
    staticClass: "color-white"
  }, [_vm._v("Homepage")])])], 1)]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }